import { useLazyQuery, useMutation } from "@apollo/client";
import { useRecoilState } from "recoil";
import {
  MY_FOLLOWERS_QUERY,
  USER_FOLLOW_MUTATION,
  USER_UNFOLLOW_MUTATION,
} from "../../GraphQL/followers";

import { AllstarUser } from "../../State";

export const useMutateFollowers = () => {
  const [allstarUser, setAllstarUser] = useRecoilState(AllstarUser);

  const [requestFollowers] = useLazyQuery(MY_FOLLOWERS_QUERY, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      const followingData = data.myFollowing.profiles;
      setAllstarUser({
        ...allstarUser,
        followers: followingData,
      });
    },
  });

  const onMutationCompleted = (
    _data: unknown,
    opts?: { variables?: { skipRequestFollowers?: boolean } },
  ) => {
    if (allstarUser.loggedIn && !opts?.variables?.skipRequestFollowers) {
      requestFollowers({
        variables: { profiles: true, clips: false },
      });
    }
  };

  const [followMutation] = useMutation(USER_FOLLOW_MUTATION, {
    onCompleted: onMutationCompleted,
  });
  const [unfollowMutation] = useMutation(USER_UNFOLLOW_MUTATION, {
    onCompleted: onMutationCompleted,
  });

  const mutateFollowers = (options: {
    variables: {
      userToFollow: string;
      follow: boolean;
      skipRequestFollowers?: boolean;
    };
  }) => {
    const { userToFollow, follow, skipRequestFollowers } = options.variables;
    const mutate = follow ? followMutation : unfollowMutation;
    return mutate({
      variables: { userId: userToFollow, skipRequestFollowers },
    });
  };

  return { requestFollowers, mutateFollowers };
};
